import React from 'react';
import PropTypes from 'prop-types';
import { Divider } from '@material-ui/core';
import { Tabs } from '@knockrentals/knock-shared-web-v2';
import { makeCss } from '../../../../../knock-design-system';
import { TAB_LIST, TAB_TITLES } from '../../constants';

const useCss = makeCss({
  tab: {
    textTransform: 'unset',
  },
  tabBar: {
    '& .MuiTabs-flexContainer': {
      justifyContent: 'space-around',
    },
  },
});

const TabBar = ({ handleOnTabChange, selectedTab, tabList }) => {
  const css = useCss();

  return (
    <React.Fragment>
      <Tabs
        css={css.tabBar}
        onChange={handleOnTabChange}
        value={selectedTab}
        variant="scrollable"
      >
        {tabList.map((tab) => (
          <Tabs.Tab
            css={css.tab}
            key={tab}
            label={TAB_TITLES[tab]}
            value={tab}
          />
        ))}
      </Tabs>
      <Divider />
    </React.Fragment>
  );
};

TabBar.propTypes = {
  handleOnTabChange: PropTypes.func,
  selectedTab: PropTypes.string,
  tabList: PropTypes.arrayOf(PropTypes.oneOf(TAB_LIST)),
};

export default TabBar;
